<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug">
</template>

<script>
export default {
  name: "wl-empty",
  props: {
    title: {
      type: String,
      required: false,
      default: '暂无数据',
    },
  },
  components: {},
  data() {
    return {
    };
  },
  watch: {},
  computed: {},
  mounted() {
    
  },
  methods: {
    
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/wl-empty/index.vue